module.exports = __webpack_public_path__ + "static/media/background.a6f594ca.jpg";